import { useMemo } from 'react';

export const useCalculatorDisplay = (value: string) => {
  const sizeClass = useMemo(() => {
    const len = value.length;
    if (len <= 8) return 'displayMainLarge';
    if (len <= 12) return 'displayMainMedium';
    if (len <= 16) return 'displayMainSmall';
    return 'displayMainTiny';
  }, [value]);

  return {
    sizeClass,
  };
};
